import {RouterProvider, createBrowserRouter} from 'react-router-dom';

import React from 'react';
import {TabNavigator} from './TabNavigator';
import {screens} from '../screens';

import useJwtAuth from "../auth/services/jwt/useJwtAuth";

import PrivateRoute from "./PrivateRoute"; // Importe o PrivateRoute corretamente


const stack = createBrowserRouter([
  {
    path: '/',
    element: <screens.Onboarding />,
  },
  {
    path: '/SignIn',
    element: <screens.SignIn />,
  },
  {
    path: '/SignUp',
    element: <screens.SignUp />,
  },
  {
    path: '/VerifyYourPhoneNumber',
    element: <PrivateRoute element={<screens.VerifyYourPhoneNumber />} />
  },
  {
    path: '/InvoiceSent',
    element: <PrivateRoute element={<screens.InvoiceSent />} />,
  },
  {
    path: '/FundTransfer',
    element: <PrivateRoute element={<screens.FundTransfer />} />,
  },
  {
    path: '/OpenNewLoan',
    element: <PrivateRoute element={<screens.OpenNewLoan />} />,
  },
  {
    path: '/CardMenu',
    element: <PrivateRoute element={<screens.CardMenu />} />,
  },
  {
    path: '/ForgotPassword',
    element: <screens.ForgotPassword />,
  },
  {
    path: '/CreateInvoice',
    element: <PrivateRoute element={<screens.CreateInvoice />} />,
  },
  {
    path: '/Statistics',
    element: <PrivateRoute element={<screens.Statistics />} />,
  },
  {
    path: '/OpenDeposit',
    element: <PrivateRoute element={<screens.OpenDeposit />} />,
  },
  {
    path: '/OpenMoneybox',
    element: <PrivateRoute element={<screens.OpenMoneybox />} />,
  },
  {
    path: '/SignUpAccountCreated',
    element: <screens.SignUpAccountCreated />,
  },
  {
    path: '/ConfirmationCode',
    element: <screens.ConfirmationCode />,
  },
  {
    path: '/PaymentFailed',
    element: <PrivateRoute element={<screens.PaymentFailed />} />,
  },
  {
    path: '/PrivacyPolicy',
    element: <screens.PrivacyPolicy />,
  },
  {
    path: '/CoverageDetails',
    element: <PrivateRoute element={<screens.CoverageDetails />} />,
  },
  {
    path: '/ChangePINCode',
    element: <screens.ChangePINCode />,
  },
  {
    path: '/IBANPayment',
    element: <PrivateRoute element={<screens.IBANPayment />} />,
  },
  {
    path: '/FAQ',
    element: <screens.FAQ />,
  },
  {
    path: '/EditPersonalInfo',
    element: <PrivateRoute element={<screens.EditPersonalInfo />} />,
  },
  {
    path: '/PaymentSuccess',
    element: <screens.PaymentSuccess />,
  },
  {
    path: '/OpenNewCard',
    element: <screens.OpenNewCard />,
  },
  {
    path: '/Payments', // Exemplo de outra rota protegida
    element: <PrivateRoute element={<screens.Payments />} />,
  },
  {
    path: '/MobilePayment',
    element: <PrivateRoute element={<screens.PaymentSuccess />} />,
  },
  {
    path: '/CardDetails',
    element: <PrivateRoute element={<screens.CardDetails />} />,
  },
  {
    path: '/TopUpPayment',
    element: <screens.TopUpPayment />,
  },
  {
    path: '/NewPassword',
    element: <screens.NewPassword />,
  },
  {
    path: '/ForgotPasswordSentEmail',
    element: <screens.ForgotPasswordSentEmail />,
  },
  {
    path: '/Profile', // Exemplo de rota protegida
    element: <PrivateRoute element={<screens.Profile />} />,
  },
  {
    path: '/TabNavigator',
    element: <PrivateRoute element={<TabNavigator />} />,
  },
]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
